module.exports = __webpack_public_path__ + "img/rakuten.dac96d67.svg";